// Порядок проектов по умолчанию — для тех, кто ничего не переставлял. Единственная общая настройка
// отображения, и меняется только здесь, а не на экране Projects, чтобы не сдвинуть его всем случайно.
import { useMemo } from 'react';
import { useTable } from '@core/store';
import { cn } from '@core/ui/cn';
import { orderRows } from '../roadmap/shared/order';
import { TD, TH } from './cells';
import { planDefaultOrder, type Runner } from './planner';

export function OrderTab({ run, busy }: { run: Runner; busy: boolean }) {
  const projects = useTable('project');
  const shared = useTable('shared_setting');
  const row = useMemo(() => [...shared.values()].find((r) => r.key === 'projects.order'), [shared]);
  const saved = Array.isArray(row?.value) ? (row.value as string[]) : [];
  const rows = useMemo(() => orderRows(projects.values(), saved), [projects, saved]);
  const ids = rows.map((p) => p.id);
  const move = (i: number, dir: -1 | 1) => {
    const j = i + dir;
    if (j < 0 || j >= ids.length) return;
    const next = [...ids]; [next[i], next[j]] = [next[j]!, next[i]!];
    void run(planDefaultOrder(next, row));
  };
  return (
    <table className="text-sm border-collapse max-w-xl" data-admin-order>
      <thead>
        <tr className="border-b border-gray-200">
          <th className={cn(TH, 'w-8')} aria-label="Position" />
          <th className={TH} title="What a person sees on Projects until they reorder rows themselves; then they see their own order and can reset to this one">Default project order</th>
          <th className={cn(TH, 'w-20')} aria-label="Move" />
        </tr>
      </thead>
      <tbody>
        {rows.map((p, i) => (
          <tr key={p.id} data-admin-order-row={p.id} className="border-b border-gray-100 hover:bg-gray-50">
            <td className={cn(TD, 'text-ink-muted text-right tabular-nums')}>{i + 1}</td>
            <td className={cn(TD, 'font-medium')}><span className="inline-block w-3 h-3 rounded-full mr-2 align-middle" style={{ background: p.color }} aria-hidden />{p.name}</td>
            <td className={TD}>
              <button type="button" className="min-h-0 w-7 h-7 rounded hover:bg-gray-200 disabled:opacity-30" disabled={busy || i === 0} aria-label={`Move ${p.name} up`} onClick={() => move(i, -1)}>↑</button>
              <button type="button" className="min-h-0 w-7 h-7 rounded hover:bg-gray-200 disabled:opacity-30" disabled={busy || i === ids.length - 1} aria-label={`Move ${p.name} down`} onClick={() => move(i, 1)}>↓</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
